export default {
  name: 'marking--ordersPool',
  apiService: 'shoes',
  apiPath: '/admin/orders_pool',
};